import * as Sentry from '@sentry/react';
import {
  captureConsoleIntegration,
  contextLinesIntegration,
  httpClientIntegration,
} from '@sentry/integrations';

export const initSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not provided. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [
      captureConsoleIntegration({ levels: ['error'] }),
      contextLinesIntegration({ frameContextLines: 7 }),
      httpClientIntegration({ failedRequestStatusCodes: [[500, 599]] }),
    ],
    sendDefaultPii: false,
  });
};

export function setSentryUser(user: Record<string, unknown> | null) {
  if (!Sentry) return;

  if (!user) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser(user);
}

export function setSentryContext(contextName: string, contextData: Record<string, unknown> | null) {
  if (!Sentry) return;

  if (!contextData) {
    Sentry.setContext(contextName, {});
    return;
  }

  Sentry.setContext(contextName, contextData);
}

export default Sentry;
